import { useEffect, useState, useCallback } from 'react'

const METHOD_LABEL = {
  get: 'Loaded',
  post: 'Saved',
  put: 'Updated',
  patch: 'Updated',
  delete: 'Deleted',
}

export function dispatchToast(response) {
  const method = response.config?.method?.toLowerCase() || 'get'
  // Only surface a toast for mutations — silent reads keep the viewer UI clean.
  if (method === 'get') return
  const message = response.data?.message || METHOD_LABEL[method] || 'Done'
  window.dispatchEvent(new CustomEvent('api-toast', { detail: { message } }))
}

let _id = 0

export default function Toast() {
  const [toasts, setToasts] = useState([])

  const remove = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id))
  }, [])

  useEffect(() => {
    const handler = (e) => {
      const id = ++_id
      setToasts((prev) => [...prev, { id, message: e.detail.message }])
      setTimeout(() => remove(id), 2500)
    }
    window.addEventListener('api-toast', handler)
    return () => window.removeEventListener('api-toast', handler)
  }, [remove])

  if (!toasts.length) return null

  return (
    <div style={styles.container}>
      {toasts.map((t) => (
        <div key={t.id} style={styles.toast}>
          <span style={styles.dot} />
          {t.message}
        </div>
      ))}
    </div>
  )
}

const styles = {
  container: {
    position: 'fixed',
    top: 16,
    right: 16,
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    pointerEvents: 'none',
  },
  toast: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '10px 16px',
    borderRadius: 10,
    background: '#1b3558',
    color: '#e8eef5',
    fontSize: 13,
    fontWeight: 500,
    fontFamily: 'inherit',
    boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
    animation: 'toastIn 0.22s ease',
  },
  dot: {
    width: 7,
    height: 7,
    borderRadius: '50%',
    background: '#4caf82',
    flexShrink: 0,
  },
}
